import { useCallback } from "react";
import { useDependencies } from "@/shared/context/DependenciesContext";

type EventCallback<T> = (data: T) => void;

export const usePush = () => {
  const { pushService } = useDependencies();

  const subscribe = useCallback(
    <T>(channelName: string, eventName: string, callback: EventCallback<T>) => {
      pushService.subscribe(channelName, eventName, callback);
    },
    [pushService],
  );

  const unsubscribe = useCallback(
    <T>(channelName: string, eventName?: string, callback?: EventCallback<T>) => {
      pushService.unsubscribe(channelName, eventName, callback);
    },
    [pushService],
  );

  const disconnect = useCallback(() => {
    pushService.disconnect();
  }, [pushService]);

  const reconnect = useCallback(() => {
    pushService.reconnect();
  }, [pushService]);

  const trigger = useCallback(
    (channelName: string, eventName: string, data: unknown) => {
      pushService.trigger(channelName, eventName, data);
    },
    [pushService],
  );

  const getConnectionState = useCallback(() => {
    return pushService.getConnectionState();
  }, [pushService]);

  return {
    subscribe,
    unsubscribe,
    trigger,
    disconnect,
    reconnect,
    getConnectionState,
  };
};
